const categories3 = [
    {
      name: '公屋',
      href: '/ProductList?type=Public',
      imageSrc: '/images/category3/public.jpg',
    },
    {
      name: '居屋',
      href: '/ProductList?type=Estate',
      imageSrc: '/images/category3/hos.jpg',
    },
    {
      name: '私樓',
      href: '/ProductList?type=Private',
      imageSrc: '/images/category3/private.jpg',
    },
    {
      name: '其他',
      href: '/ProductList?type=Others',
      imageSrc: '/images/category2/hk.jpg',
    },
]

export default function MainCategoryHouseType() {
    return (
        <>
            {/* According to area */}
            <div className="bg-white mt-6 lg:mt-16">
                <div className="xl:max-w-7xl xl:mx-auto xl:px-8">
                    <div className="px-4 sm:px-6 sm:flex sm:items-center sm:justify-between lg:px-8 xl:px-0">
                        <h2 className="lg:text-xl font-extrabold tracking-tight text-gray-900 sm:text-lg">根據查看裝修案例</h2>
                        <a href='/ProductList' className="hidden text-sm font-semibold text-cyan-900 hover:text-cyan-600 sm:block">
                            查看全部案例<span aria-hidden="true"> &rarr;</span>
                        </a>
                    </div>

                    <div className="relative">
                        <div className="relative w-full pb-6 -mb-6 overflow-x-auto lg:mt-8 mt-4">
                            <ul
                                className="mx-4 inline-flex space-x-8 sm:mx-6 lg:mx-0 lg:space-x-0 lg:grid lg:grid-cols-4 lg:gap-x-8"
                            >
                                {categories3.map((category) => (
                                    <a
                                        key={category.name}
                                        href={category.href}
                                        className=" lg:mb-4 relative w-64 lg:h-48 h-36 rounded-lg p-6 flex flex-col overflow-hidden hover:opacity-75 xl:w-auto"
                                    >
                                        <span aria-hidden="true" className="absolute inset-0">
                                            <img src={category.imageSrc} alt="" className="w-full h-full object-center object-cover" />
                                        </span>
                                        <span
                                            aria-hidden="true"
                                            className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-gray-800 opacity-50"
                                        />
                                        <span className="relative mt-auto lg:text-xl font-bold text-white sm:text-lg text-center">{category.name}</span>
                                    </a>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="mt-6  px-4 sm:hidden">
                        <a href='/ProductList' className="block text-sm font-semibold text-cyan-900 hover:text-cyan-600">
                            查看全部案例<span aria-hidden="true"> &rarr;</span>
                        </a>
                    </div>
                </div>
            </div>
            {/* end of area */}
        </>
    )
}